import { useState } from 'react';
import { PropTypes } from 'base/react-libs';
import { Icon, Button } from '@evertrue/et-components';
import Loading from 'components/elements/loading';
import RecommendedActionRow from './recommended-action-row';
import EmptyRecommendedSection from './empty-recommended-section';

const RecommendedActionSection = ({
  title,
  subtitle,
  recommendedActions = [],
  icon,
  emailButtonLabel,
  secondaryActionLabel,
  iconKit = 'gt2',
  type = 'gift',
  loading,
}) => {
  // This is unfortunate, but we don't have a better way to sort the recommended actions by last_gift_date
  const [recommendations, setRecommendations] = useState(
    recommendedActions.sort((a, b) => {
      const dateA = a?.contact?.giving?.last_gift_date;
      const dateB = b?.contact?.giving?.last_gift_date;

      if (dateA && dateB) {
        return new Date(dateB) - new Date(dateA);
      } else if (!dateA && dateB) {
        return 1; // If dateA is null and dateB is not, sort b before a
      } else if (dateA && !dateB) {
        return -1; // If dateB is null and dateA is not, sort a before b
      } else {
        return 0; // If both are null or both exist, maintain original order
      }
    })
  );
  const [showAll, setShowAll] = useState(false);

  const handleViewClick = (recommendation) => {
    const recommendationsCopy = [...recommendations];
    const filtered = recommendationsCopy.filter((rec) => rec.id !== recommendation.id);
    setRecommendations(filtered);
  };

  return (
    <>
      <div className="homepage-recommendations-section-title">
        <Icon icon={icon} iconKit={iconKit} />
        <h6>{title}</h6>
      </div>
      <div>
        {loading ? (
          <div style={{ paddingTop: '18px', height: '42px', marginBottom: '10px', marginTop: '10px' }}>
            <Loading spinner_size={'small'} className={'loader-icon'} />
          </div>
        ) : (
          <>
            {recommendations?.length > 0 ? (
              <>
                {recommendations?.slice(0, showAll ? recommendations?.length : 3).map((recommendation, index) => (
                  <RecommendedActionRow
                    recommendation={recommendation}
                    key={recommendation.id}
                    type={type}
                    first={index === 0}
                    subtitle={subtitle}
                    emailButtonLabel={emailButtonLabel}
                    secondaryActionLabel={secondaryActionLabel}
                    handleViewClick={handleViewClick}
                    icon={icon}
                    iconKit={iconKit}
                  />
                ))}
                {recommendedActions?.length > 3 && (
                  <div style={{ paddingBottom: '8px' }}>
                    <Button type="simple" onClick={() => setShowAll(!showAll)}>
                      {showAll ? 'View Less' : 'View All'}
                    </Button>
                  </div>
                )}
              </>
            ) : (
              <EmptyRecommendedSection subtitle={subtitle} />
            )}
          </>
        )}
      </div>
    </>
  );
};

RecommendedActionSection.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  recommendedActions: PropTypes.array,
  icon: PropTypes.string,
  emailButtonLabel: PropTypes.string,
  secondaryActionLabel: PropTypes.string,
  iconKit: PropTypes.string,
  type: PropTypes.string,
  loading: PropTypes.bool,
};

export default RecommendedActionSection;
